var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36866 7.36914C4.91533 7.36914 4.54199 7.74247 4.54199 8.2047V15.0758C4.54199 15.5291 4.91533 15.9025 5.36866 15.9025C5.83088 15.9025 6.20421 15.5291 6.20421 15.0758V8.2047C6.20421 7.74247 5.83088 7.36914 5.36866 7.36914Z",
    fill: "#585969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 4.08887C9.58183 4.08887 9.2085 4.4622 9.2085 4.92442V15.0755C9.2085 15.5289 9.58183 15.9022 10.0352 15.9022C10.4974 15.9022 10.8707 15.5289 10.8707 15.0755V4.92442C10.8707 4.4622 10.4974 4.08887 10.0352 4.08887Z",
    fill: "#585969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6398 10.9961C14.1775 10.9961 13.8042 11.3694 13.8042 11.8316V15.0761C13.8042 15.5294 14.1775 15.9028 14.6309 15.9028C15.0931 15.9028 15.4664 15.5294 15.4664 15.0761V11.8316C15.4664 11.3694 15.0931 10.9961 14.6398 10.9961Z",
    fill: "#585969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.1b9371546135b7e674cc78bc3a979876.svg";
export { ForwardRef as ReactComponent };